
<nav-bar></nav-bar>
<hoc-search [bodyComponent]="contentComponent" page="results"></hoc-search>
